import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {catchError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {EntityKey} from '../entity/entity';
import {RiserUploadResponse} from '../riser/riser-upload-response';
import {GoogleService} from './google-service';
import {FileUtils} from "../utils/file-utils";

@Service()
export class RiserUploadService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private readonly urlBase: string = environment.serviceUrl;

  public getTemplate(id: EntityKey): Observable<Blob> {
    const url: string = this.urlBase + 'risers/template/' + id.entityId + '/' + id.entityRevision;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'body',
      responseType: 'blob'
    }).pipe(catchError((error: any) => FileUtils.handleBlobError(error)));
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public uploadRisers(key: EntityKey, fileBytes: Uint8Array): Observable<RiserUploadResponse> {
    const url: string = this.urlBase + 'risers/upload/' + key.entityId + '/' + key.entityRevision;
    return this.http.post<RiserUploadResponse>(url, fileBytes, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/octet-stream");
  }

}
